import { Observable } from 'rxjs';
import { WsSyncActiveItem, WsSyncToggleCommand } from '../interfaces/ws-sync-state.types';

export abstract class WsSyncConfigRepository {
  abstract toggleSync(command: WsSyncToggleCommand): Observable<void>;
  abstract listActive(): Observable<WsSyncActiveItem[]>;
}
